import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CirclePlay } from "lucide-react";
import { applyDocLang, Brand } from "@/components/brand";
import PromoVideo from "@/components/PromoVideo";
import { CONTACT_EMAIL } from "@/lib/site";
import { useSeo } from "@/lib/seo";

export default function Tanitim() {
  useSeo({
    title: "RateGuard tanıtım videosu · Otel misafir geri bildirimi 45 saniyede",
    description: "RateGuard 45 saniyede: misafir odadaki QR'ı okutur, şikâyet anında resepsiyona sesli uyarıyla düşer, memnun misafir Google'da yorum bırakır.",
    path: "/tanitim",
  });
  useEffect(() => {
    applyDocLang("tr");
  }, []);

  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="floor" />
      <header className="wrap flex items-center justify-between" style={{ paddingBlock: "1.2rem" }}>
        <Brand to="/" />
        <a href="/#demo" className="btn btn-primary btn-sm">Demo iste</a>
      </header>

      <main className="wrap text-center" style={{ paddingBlock: "clamp(1.5rem, 5vw, 3.5rem) 4rem" }}>
        <div className="eyebrow mb-3">45 saniyede RateGuard</div>
        <h1 className="display mx-auto" style={{ fontSize: "clamp(2rem, 5.4vw, 3.6rem)", maxWidth: "20ch" }}>
          Kötü yorum Google'a düşmeden, <em>şikâyet resepsiyonda.</em>
        </h1>
        <p className="lede mx-auto mt-4" style={{ maxWidth: "52ch" }}>
          Misafir odadaki QR'ı okutur. Memnun değilse resepsiyona sesli uyarı gelir, memnunsa Google'da yorum bırakır.
        </p>

        <div className="mt-8">
          <PromoVideo testId="tanitim-video" />
        </div>

        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <a href="/#demo" className="btn btn-primary" data-testid="tanitim-demo">
            Otelim için demo istiyorum <ArrowRight size={18} />
          </a>
          <Link to="/demo/101" className="btn btn-secondary" data-testid="tanitim-try">
            <CirclePlay size={18} /> Misafir ekranını deneyin
          </Link>
        </div>
        <p className="faint text-sm mt-6">
          Sorunuz mu var? <a href={`mailto:${CONTACT_EMAIL}`} className="underline">{CONTACT_EMAIL}</a>
        </p>
      </main>
    </div>
  );
}
